export type OfflineMeasurementInfo = {
  measurementUuid: string;

  roomName: string;
  holeSizeWidth: string;
  holeSizeHeight: string;
  joinerySizeWidth: string;
  joinerySizeHeight: string;

  windowComment?: string | null;
  windowBottomAddition: string;
  windowBottomAdditionSize: string;
  windowBottomAdditionComment?: string | null;
  windowSideAddition: string;
  windowSideAdditionSize: string;
  windowSideAdditionComment?: string | null;

  typeOfSlidingWindow?: string | null;
  comment?: string | null;
  warningComment?: string | null;

  // request wysyła same uuid / uuid+comment; UI czyta `windowAdditionUuids`
  windowAdditionUuids: Array<string | { uuid: string; comment?: string }>;

  // w online current-info wraca też lista plików; w offline trzymamy to jako dowolny JSON
  file?: any[];

  updatedAt: string;
};

type OfflineMeasurementInfoState = Record<string, OfflineMeasurementInfo>;

const STORAGE_KEY = 'offlineMeasurementInfo';

const readState = (): OfflineMeasurementInfoState => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return (JSON.parse(raw) as OfflineMeasurementInfoState) || {};
  } catch (e) {
    console.error('Error reading offline measurement info:', e);
    return {};
  }
};

const writeState = (state: OfflineMeasurementInfoState) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (e) {
    console.error('Error writing offline measurement info:', e);
  }
};

export const upsertOfflineMeasurementInfo = (info: OfflineMeasurementInfo) => {
  const state = readState();
  writeState({
    ...state,
    [info.measurementUuid]: info,
  });
};

export const getOfflineMeasurementInfo = (
  measurementUuid: string
): OfflineMeasurementInfo | null => {
  const state = readState();
  return state[measurementUuid] || null;
};

export const clearOfflineMeasurementInfo = () => {
  writeState({});
};
